import MessageTriggers from './MessageTriggers';

export default MessageTriggers;
